let toggleButtons = document.querySelectorAll('.menu__item-toggle-button');

if (toggleButtons.length > 0) {
    let openClass = 'open';

    for (let $toggleButton of toggleButtons) {
        $toggleButton.addEventListener('click', () => {
            let level = $toggleButton.dataset.level;
            let $submenu = $toggleButton.closest('.menu__item').querySelector('.menu__sub-item[data-level="' + level + '"]');

            if ($toggleButton.classList.contains(openClass)) {
                $toggleButton.classList.remove(openClass);
                $submenu.classList.remove(openClass);
            } else {
                $toggleButton.classList.add(openClass);
                $submenu.classList.add(openClass);
            }

            // $submenu

        });


    }
}